import script from "./form-item.vue?vue&type=script&setup=true&lang=js"
export * from "./form-item.vue?vue&type=script&setup=true&lang=js"

import "./form-item.vue?vue&type=style&index=0&id=20a080de&lang=css"

const __exports__ = script;

export default __exports__